import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    period,
    firstTime,
    additional,
    taxpayerName,
    taxId,
    city,
    district,
    ward,
    village,
    road,
    apartment,
    taxAgentName,
    taxAgentId,
    taxAgentContract,
    daytaxAgentContract,

    startingTime,
    timeOfChange,
    taxExemption,
    compulsoryTax,
    taxPrice,
    taxMustBePaid,

    fullName,
    certificate,
    signer,
    timeSign,
  },
} = checkout;

const validation = Yup.object().shape({
  [period.name]: Yup.string().required(period.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [additional.name]: Yup.string().notRequired(additional.errorMsg),
  [taxpayerName.name]: Yup.string().required(taxpayerName.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),

  [city.name]: Yup.string().required(city.errorMsg),
  [district.name]: Yup.string().required(district.errorMsg),
  [ward.name]: Yup.string().required(ward.errorMsg),
  [village.name]: Yup.string().required(village.errorMsg),
  [road.name]: Yup.string().required(road.errorMsg),
  [apartment.name]: Yup.string().required(apartment.errorMsg),
  [taxAgentContract.name]: Yup.string().required(taxAgentContract.errorMsg),
  [daytaxAgentContract.name]: Yup.string().required(daytaxAgentContract.errorMsg),

  [startingTime.name]: Yup.string().required(startingTime.errorMsg),
  [timeOfChange.name]: Yup.string().required(timeOfChange.errorMsg),
  [taxExemption.name]: Yup.string().required(taxExemption.errorMsg),
  [compulsoryTax.name]: Yup.string().required(compulsoryTax.errorMsg),
  [taxPrice.name]: Yup.string().required(taxPrice.errorMsg),
  [taxMustBePaid.name]: Yup.string().required(taxMustBePaid.errorMsg),

  [taxAgentName.name]: Yup.string().notRequired(taxAgentName.errorMsg),
  [taxAgentId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgentId.invalidMsg)
    .notRequired(taxAgentId.errorMsg),

  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
});

export default validation;
